import conf from '../config/api.js';
import Vue from 'vue';
import vuexStorage from '../store/index.js'

var moment = require('moment');
var htmlDecode = require('js-htmlencode').htmlDecode;

//Fonction génération de toaster erreur
function toasterError(content, title){
  new Vue().$bvToast.toast(content, {
    title: title,
    toaster: 'b-toaster-bottom-right',
    variant: 'danger',
    autoHideDelay: 2500,
    appendToast: true,
    solid: true
  })
}

//Fonction qui permet d'ajouter la class active au menu profil du client
function activeClassMenuProfil(){
  var url = window.location.pathname;
  var classActive = document.getElementById("navigation");
  for(var i=0;i<classActive.children.length;i++){
    classActive.children[i].children[0].classList.remove("active");
    classActive.children[i].children[0].classList.remove("router-link-exact-active");
    classActive.children[i].children[0].classList.remove("router-link-active");

    var path = classActive.children[i].children[0].getAttribute("href");
    if(path==url){
      classActive.children[i].children[0].classList.add("active");
      classActive.children[i].children[0].classList.add("router-link-exact-active");
      classActive.children[i].children[0].classList.add("router-link-active");
    }
  }
}

//Fonction d'ajout d'un contact
async function addContact (formData) {
  try {
    await requestApi({method:"POST", url:"/api/addContact", params:{}, form:formData, headers:{'Content-Type': 'application/json'}});
    this.$bvToast.toast(`Le contact a été ajouté`, {
      title: 'Ajout d\'un contact',
      toaster: 'b-toaster-bottom-right',
      variant: 'success',
      autoHideDelay: 2500,
      appendToast: true,
      solid: true
    });
  } catch (error) {
    if(error.response != undefined){
      toasterError(`Ajout de contact impossible`,'Ajout de contact');
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible');
      this.$router.push('login');
    }
  }
}

//Fonction d'ajout en masse de compte
function addMassiveContact(){
  for(var i=0;i<this.selectedContact.length;i++){
    iterateMassiveContact.call(this,this.selectedContact[i],this.templateSelected);
  }
}

//Fonction de modification des infos perso du client
async function changeInfoPerso(infoClients, infoPerso){
  var key = Object.keys(infoPerso);
  var changeInfo = [];
  var j = 0;
  for(var i=0;i<key.length;i++){
    if((infoClients[key[i]] != infoPerso[key[i]])&&(key[i]!="array_options")){
      changeInfo[j] = new Array(2);
      changeInfo[j][0] = key[i];
      changeInfo[j][1] = infoPerso[key[i]];
      j++;
    }
  }
  
  if(changeInfo){
    try {
      var response = await requestApi({method:"POST", url:"/api/changeInfoPerso", params:{}, form:changeInfo, headers:{'Content-Type': 'application/json'}});
      alert(response);
    } catch (error) {
      if(error.response != undefined){
        this.$bvToast.toast(`Changement d'information impossible`, {
          title: 'Changement d\'informations',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          autoHideDelay: 2500,
          appendToast: true,
          solid: true
        })
        if(error.response.data.route!=null){
          this.$router.push(error.response.data.route);
        }
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    }
  }
}

//Fonction envoi mail changement de mot de passe
async function changePassOublie(){
  try {
    await requestApi({method:"POST", url:"/api/createToken", params:{}, form:{email:this.loginOublie}, headers:{'Content-Type': 'application/json'}});
    this.$bvToast.toast(`Un lien vient de vous être envoyé dans votre boîte mail`, {
      title: 'Changement de mot de passe',
      toaster: 'b-toaster-bottom-right',
      variant: 'success',
      autoHideDelay: 2500,
      appendToast: true,
      solid: true
    })
    this.$router.push('login');
  } catch (error) {
    if(error.response != undefined){
      toasterError(`Changement de mot de passe impossible`,'Changement de mot de passe')
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      this.$router.push('login');
    }
  }
}

//Fonction de changement de mot de passe 
async function changePassword(form){
  if(form.newPwd == form.newPwd2){
    try {
      await requestApi({method:"POST", url:"/api/changePassword", params:{}, form:form, headers:{'Content-Type': 'application/json'}});
      alert("Votre mot de passe à été changé vous allez être redirigé vers la page de login");
      try {
        var response = await requestApi({method:"POST", url:"/api/disconnect", params:{}, form:{}, headers:{'Content-Type': 'application/json'}});
        this.$router.push(response.route);
      } catch (error) {
        this.$router.push('login');
      }
    } catch (error) {
      if(error.response != undefined){
        toasterError(error.response,'Changement de mot de passe')
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    }
  }else{
    toasterError(`Les mots de passe ne correspondent pas`,'Changement de mot de passe')
  }
}

//Fonction de connexion sur un compte client un compte admin
async function connectOnClient(clientId,socId){
  var connected = confirm("Voulez-vous vous connecter au compte de ce client?");
  if(connected){
    try {
      var response = await requestApi({method:"POST", url:"/api/connectAdminClient", params:{}, form:{clientId: clientId, socid: socId}, headers:{'Content-Type': 'application/json'}});
      this.$router.push(response.route);
    } catch (error) {
      if(error.response != undefined){
        toasterError(`Connexion au compte client impossible`,'Connexion compte client')
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        this.$router.push('login');
      }  
    }
  }
}

//Fonction de création d'accès client
async function createAccess(email,contenuMail,pwd,tokenReinit){
  try {
    var response = await requestApi({method:"POST", url:"/api/createAccess", params:{}, form:{email: email, contenuMail: contenuMail, pwd: pwd, tokenReinit:tokenReinit}, headers:{'Content-Type': 'application/json'}});
    alert("Accès créée avec succès!");
    this.loadingClient();
    this.expandClientInfo(response.socid);
  } catch (error) {
    if(error.response != undefined){
      toasterError(`Connexion au compte client impossible`,'Connexion compte client')
    }else{
      if(error.response != undefined){
        toasterError(`Création d'accès impossible`,'Création d\'accès')
        if(error.response.data.route!=null){
          this.$router.push(error.response.data.route);
        }
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        this.$router.push('login');
      }
    }  
  }
}

//Fonction de suppression d'un contact
async function delContact (id) {
  try {
    await requestApi({method:"POST", url:"/api/delContact", params:{}, form:{id:id}, headers:{'Content-Type': 'application/json'}});
    this.$bvToast.toast(`Le contact a été supprimé`, {
      title: 'Suppression d\'un contact',
      toaster: 'b-toaster-bottom-right',
      variant: 'success',
      autoHideDelay: 2500,
      appendToast: true,
      solid: true
    })
  } catch (error) {
    if(error.response != undefined){
      toasterError(`Suppression de contact impossible`,'Suppression de contact')
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  }
}

//Fonction de suppression d'accès client
async function deleteAccess(contactid,socid){
  var deleteExtranet = confirm("Etes-vous sûr de vouloir supprimer l'accès à l'extranet de ce client?");
  if(deleteExtranet == true){
    try {
      let response = await requestApi({method: 'POST', url: '/api/deleteAccess', params: {}, form: {id: contactid}, headers: {'Content-Type': 'application/json'}});
      this.expandClientInfo(socid);
    } catch (error) {
      if(error.response != undefined){
        toasterError(`Suppression d'accès impossible`,'Suppression d\'accès')
        if(error.response.data.route!=null){
          this.$router.push(error.response.data.route);
        }
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        this.$router.push('login');
      }
    }
  }
}

//Fonction de suppression de tiers
async function deleteTiers(id){
  var deleteClient = confirm("Voulez-vous supprimer le tiers?");
  if(deleteClient == true){
    try {
      let response = await requestApi({method: 'POST', url: '/api/deleteTiers', params: {}, form: {id: id}, headers: {'Content-Type': 'application/json'}});
      if(response!=0){
        this.$bvToast.toast(`Le tiers à été supprimé avec succès`, {
          title: 'Suppression de tiers',
          toaster: 'b-toaster-bottom-right',
          variant: 'success',
          autoHideDelay: 2500,
          appendToast: true,
          solid: true
        })
      }else{
        this.$bvToast.toast(`Le tiers ne peut pas être supprimé car il y a un document en cours d'édition`, {
          title: 'Suppression de tiers',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          autoHideDelay: 2500,
          appendToast: true,
          solid: true
        })
      }
      this.loadingClient();
    } catch (error) {
      this.$bvToast.toast(`Suppression impossible`, {
        title: 'Suppression de tiers',
        toaster: 'b-toaster-bottom-right',
        variant: 'danger',
        autoHideDelay: 2500,
        appendToast: true,
        solid: true
      })
    }
  }
}

//Fonction de chargement des infos des clients
async function detailsTiers (id, that) {
  if(!that){
    that = this
  }
  try{
    let response = await requestApi({method: 'GET', url: '/api/detailsTiers', params: {id: id}, form: {}, headers: {'Content-Type': 'application/json'}})
    vuexStorage.commit('updateInfoSoc', response)
    var arrayOptions = response.array_options
    if(Object.keys(arrayOptions).length){
      if(arrayOptions.options_cotation){
        var cotation = JSON.parse(arrayOptions.options_cotation)
        vuexStorage.commit('updateCotation', cotation)
      }
      else {
        vuexStorage.commit('updateCotation', Object.assign({}, vuexStorage.state.cotationDefault))
      }

      if(arrayOptions.options_familles_risques){
        var famillesRisques = JSON.parse(arrayOptions.options_familles_risques)
        vuexStorage.commit('initializeFamillesRisques', famillesRisques)
      }
      else {
        vuexStorage.commit('initializeFamillesRisques', Object.assign({}, vuexStorage.state.famillesRisquesDefault))
      }

      if(arrayOptions.options_unite){
        var unite = JSON.parse(arrayOptions.options_unite)
        vuexStorage.commit('initializeUnites', unite)
      }
      else {
        vuexStorage.commit('initializeUnites', [])
      }
      
      if(arrayOptions.options_situations){
        var situations = JSON.parse(arrayOptions.options_situations)
        vuexStorage.commit('initializeSituations', situations)
      }
      else {
        vuexStorage.commit('initializeSituations', [])
      }
      
      if(arrayOptions.options_donnees){
        var donnees = JSON.parse(arrayOptions.options_donnees)
        vuexStorage.commit('initializeDonnees', donnees)
      }
      else {
        vuexStorage.commit('initializeDonnees', {unites:[]})
      }

      if(arrayOptions.options_auto_increment_unite){
        vuexStorage.commit('updateAutoIncrementUnite', arrayOptions.options_auto_increment_unite)
      }
      else {
        vuexStorage.commit('updateAutoIncrementUnite', 0)
      }
      
      if(arrayOptions.options_auto_increment_situation){
        vuexStorage.commit('updateAutoIncrementSituation', arrayOptions.options_auto_increment_situation)
      }
      else {
        vuexStorage.commit('updateAutoIncrementSituation', 0)
      }
      
      if(arrayOptions.options_auto_increment_penibilite){
        vuexStorage.commit('updateAutoIncrementPenibilite', arrayOptions.options_auto_increment_penibilite)
      }
      else {
        vuexStorage.commit('updateAutoIncrementPenibilite', 0)
      }
      
      if(arrayOptions.options_auto_increment_famille){
        vuexStorage.commit('updateAutoIncrementFamille', arrayOptions.options_auto_increment_famille)
      }
      else {
        vuexStorage.commit('updateAutoIncrementFamille', vuexStorage.state.autoIncrementFamilleDefault)
      }

      if(arrayOptions.options_auto_increment_risque){
        vuexStorage.commit('updateAutoIncrementRisque', arrayOptions.options_auto_increment_risque)
      }
      else {
        vuexStorage.commit('updateAutoIncrementRisque', vuexStorage.state.autoIncrementRisqueDefault)
      }
      
      if(arrayOptions.options_date_maj){
        vuexStorage.commit('updateDateMaj', arrayOptions.options_date_maj)
      }
      else {
        vuexStorage.commit('updateDateMaj', null)
      }
      
      if(arrayOptions.options_date_creation){
        vuexStorage.commit('updateDateCreation', arrayOptions.options_date_creation)
      }
      else {
        vuexStorage.commit('updateDateCreation', null)
      }
      
      if(arrayOptions.options_infos_generales){
        var infosGenerales = JSON.parse(arrayOptions.options_infos_generales)
        vuexStorage.commit('initializeInfosGenerales', infosGenerales)
      }
      else {
        let infosGenerales = {
          'activite':'Saisir l\'activité de l\'entreprise',
          'effectifETP':'Non défini',
          'effectifHomme':'Non défini',
          'effectifFemme':'Non défini',
          'cddIntérimaires':'Non défini',
          'horrairesDeTravail':'Non défini',
          'tempsDeTravail':'Non défini',
          'conventionCollective':'Non défini',
          'cse':'Non défini',
          'cssct':'Non défini',
          'protectionIndividuel':'Non défini',
          'caractLocaux':'Non défini',
          'hygiene':'Non défini',
          'docConsulte':'Non défini',
          'accidentDeTravail':'Non défini',
          'maladiePro':'Non défini'
        }
        vuexStorage.commit('initializeInfosGenerales', infosGenerales)
      }

      if(arrayOptions.options_auto_increment_checklist){
        vuexStorage.commit('updateAutoIncrementChecklist', arrayOptions.options_auto_increment_checklist)
      }
      else {
        vuexStorage.commit('updateAutoIncrementChecklist', 0)
      }

      if(arrayOptions.options_auto_increment_prog_action){
        vuexStorage.commit('updateAutoIncrementProgAction', arrayOptions.options_auto_increment_prog_action)
      }
      else {
        vuexStorage.commit('updateAutoIncrementProgAction', 0)
      }

      if(arrayOptions.options_checklist_generale){
        vuexStorage.commit('updateChecklistGenerale', JSON.parse(arrayOptions.options_checklist_generale))
      }
      else {
        let checklistGenerale = {
          affichageObligatoire:[],
          dispositionApplicable:[],
          locauxEntreprise:[],
          organisationGestionSecurite:[],
          organisationSecours:[],
          accidentTravail:[]
        }
        vuexStorage.commit('updateChecklistGenerale', checklistGenerale)
      }

      if(arrayOptions.options_annexe_covid){
        vuexStorage.commit('updateAnnexeCovid', JSON.parse(arrayOptions.options_annexe_covid))
      }
      else {
        let annexeCovid = {
          travailRisque:{
            salarie:{
              bref:{
                unite:"0",
                salarie:"0"
              },
              rapproche:{
                unite:"0",
                salarie:"0"
              }
            },
            public:{
              bref:{
                unite:"0",
                salarie:"0"
              },
              rapproche:{
                unite:"0",
                salarie:"0"
              }
            }
          },
          preventionOrga:{
            mesuresGenerales:"-",
            modification:"-"
          },
          preventionTechnique:{
            protectionCollective:"-",
            protectionIndividuelle:"-",
            modification:"-"
          },
          casContamination:{
            procedure:"-"
          },
          informationInterne:{
            modalite:"-"
          },
          identificationPersonne:{
            presencePersonneRisque:[],
            autrePersonneRisque:[]
          }
        }
        vuexStorage.commit('updateAnnexeCovid', annexeCovid)
      }

      if(arrayOptions.options_prog_action){
        vuexStorage.commit('initializeProgAction', JSON.parse(arrayOptions.options_prog_action))
      }
      else {
        vuexStorage.commit('initializeProgAction', [])
      }

    } else {
      vuexStorage.commit('updateCotation', Object.assign({}, vuexStorage.state.cotationDefault))
      vuexStorage.commit('initializeFamillesRisques', Object.assign({}, vuexStorage.state.famillesRisquesDefault))
      vuexStorage.commit('updateAutoIncrementRisque', vuexStorage.state.autoIncrementRisqueDefault)
      vuexStorage.commit('updateAutoIncrementFamille', vuexStorage.state.autoIncrementFamilleDefault)
      vuexStorage.commit('initializeDonnees', {unites:[]})
      vuexStorage.commit('initializeUnites', [])
      let infosGenerales = {
        'activite':'Saisir l\'activité de l\'entreprise',
        'effectifETP':'Non défini',
        'effectifHomme':'Non défini',
        'effectifFemme':'Non défini',
        'cddIntérimaires':'Non défini',
        'horrairesDeTravail':'Non défini',
        'tempsDeTravail':'Non défini',
        'conventionCollective':'Non défini',
        'cse':'Non défini',
        'cssct':'Non défini',
        'protectionIndividuel':'Non défini',
        'caractLocaux':'Non défini',
        'hygiene':'Non défini',
        'docConsulte':'Non défini',
        'accidentDeTravail':'Non défini',
        'maladiePro':'Non défini'
      }
      vuexStorage.commit('initializeInfosGenerales', infosGenerales)
      vuexStorage.commit('updateDateMaj', null)
      vuexStorage.commit('updateDateCreation', null)
      vuexStorage.commit('updateAutoIncrementPenibilite', 0)
      vuexStorage.commit('updateAutoIncrementSituation', 0)
      vuexStorage.commit('updateAutoIncrementChecklist', 0)
      vuexStorage.commit('updateAutoIncrementProgAction', 0)
      let checklistGenerale = {
        affichageObligatoire:[],
        dispositionApplicable:[],
        locauxEntreprise:[],
        organisationGestionSecurite:[],
        organisationSecours:[],
        accidentTravail:[]
      }
      vuexStorage.commit('updateChecklistGenerale', checklistGenerale)
      let annexeCovid = {
        travailRisque:{
          salarie:{
            bref:{
              unite:"0",
              salarie:"0"
            },
            rapproche:{
              unite:"0",
              salarie:"0"
            }
          },
          public:{
            bref:{
              unite:"0",
              salarie:"0"
            },
            rapproche:{
              unite:"0",
              salarie:"0"
            }
          }
        },
        preventionOrga:{
          mesuresGenerales:"-",
          modification:"-"
        },
        preventionTechnique:{
          protectionCollective:"-",
          protectionIndividuelle:"-",
          modification:"-"
        },
        casContamination:{
          procedure:"-"
        },
        informationInterne:{
          modalite:"-"
        },
        identificationPersonne:{
          presencePersonneRisque:[],
          autrePersonneRisque:[]
        }
      }
      vuexStorage.commit('initializeAnnexeCovid', annexeCovid)
      vuexStorage.commit('initializeProgAction', [])
      vuexStorage.commit('initializeSituations', [])
    }
  }catch(error){
    if(error.response != undefined){
      toasterError(`Impossible de charger les détails du tiers`,'Détails du tiers')
      if(error.response.status!=404){
        that.$router.push('/');
      }else{
		    that.$router.push('/');
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      that.$router.push('../tiers');
    }
  }
}

//Fonction de déconnexion
async function disconnect() {
  var disconnected = confirm("Voulez-vous vous déconnecter?");
  if(disconnected == true){
    try {
      await requestApi({method:"POST", url:"/api/disconnect", params:{}, form:{}, headers:{'Content-Type': 'application/json'}});
    } catch (error) {
      console.error(error);
    }
    this.$router.push('/');
  }
}

//Fonction de chargement des infos d'accès du client
async function expandClientInfo(id){
  try {
    var response = await requestApi({method:"GET", url:"/api/verifyAccess/", params:{id: id}, form:{}, headers:{'Content-Type': 'application/json'}});
    this.clientsExtranet = response;
    try {
      var response2 = await requestApi({method:"POST", url:"/api/loadingContacts/", params:{}, form:{id: id}, headers:{'Content-Type': 'application/json'}});
      this.infosContacts = response2;
      for(var j=0; j<this.infosContacts.length; j++){
        this.infosContacts[j]["acces"]=false;
      }
      for(var i=0; i<this.clientsExtranet.length; i++){
        for(j=0; j<this.infosContacts.length; j++){
          if(this.infosContacts[j]["id"]==this.clientsExtranet[i]["contact_id"]){
            this.infosContacts[j]["acces"]=true;
            var dateC = new Date(this.clientsExtranet[i]["datec"]*1000);
            var jour = dateC.getDate();
            if(jour < 10){
              jour = '0' + jour;
            }
            var mois = dateC.getMonth()+1;
            if (mois < 10) { 
              mois = '0' + mois; 
            }
            var annee = dateC.getFullYear();
            this.infosContacts[j]["datec"]=annee+"-"+mois+"-"+jour;
          }
        }
      }
    } catch (error) {
      if(error.response != undefined){
        toasterError(`Chargement des contacts impossible`,'Chargement des contacts')
        if(error.response.data.route!=null){
          this.$router.push(error.response.data.route);
        }
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    }
  } catch (error) {
    try {
      var response3 = await requestApi({method:"POST", url:"/api/loadingContacts", params:{}, form:{id: id}, headers:{'Content-Type': 'application/json'}});
      this.infosContacts = response3;
    } catch (error2) {
      if(error2.response != undefined){
        toasterError(`Chargement des contacts impossible`,'Chargement des contacts')
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    }
    if(error.response != undefined){
      toasterError(`Impossible d'effectuer la vérification`,'Verification')
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  }
}

//Fonction de récupération des infos perso du client
async function getInfoClient(){
  try {
    this.infoClients = await requestApi({method:"GET", url:"/api/getInfoPersoClient", params:{}, form:{}, headers:{'Content-Type': 'application/json'}});
    this.infoPerso = JSON.parse(JSON.stringify(this.infoClients));
  } catch (error) {
    if(error.response != undefined){
      toasterError(`Impossible de charger les informations client`,'Chargement des infos')
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  }
}

//Fonction de récupération des infos de la société du client
async function getInfoSocClient(){
  try {
    this.infoSocClient = await requestApi({method:"GET", url:"/api/getInfoSocClient", params:{}, form:{}, headers:{'Content-Type': 'application/json'}});
  } catch (error) {
    if(error.response != undefined){
      toasterError(`Impossible de charger les informations de la société`,'chargement des infos de société')
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  }
}

//Fonction de génération des infos à envoyer au client  
async function info(row,target) {
  this.form.email=row.email;
  this.modalInfo.title = 'Contact: '+row.firstname+' '+row.lastname;
  try {
    var response = await requestApi({method:"POST", url:"/api/passwordGenerator", params:{}, form:{email: row.email}, headers:{'Content-Type': 'application/json'}});
    this.pwd = response.pwd;
    this.tokenReinit = response.tokenReinit;
    this.loadingTemplateMail(this.templateSelected,this.form.email,this.pwd,this.tokenReinit);
  } catch (error) {
    if(error.response != undefined){
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  }
  this.$root.$emit('bv::show::modal', 'modalInfo',target);
}

//Fonction de vérification de connexion pour la page login
//Si l'utilisateur est connecté il est redirigé vers la page index
async function isConnect(){
  try {
    var response = await requestApi({method:"POST", url:"/api/isConnect", params:{}, form:{}, headers:{'Content-Type': 'application/json'}});
    this.$router.push(response.route);
  } catch (error) {
    this.$router.push('login');
  }
}

//Fonction pour itérer massive contact
function iterateMassiveContact(user,template){
  var email = user.email;
  var nom = user.lastname;
  var prenom = user.firstname;
  this.axios.post(conf.server+"/api/passwordGenerator",{email:email},{withCredentials:true})
  .then((response) => {
    var pwd = response.data.pwd;
    var tokenReinit = response.data.tokenReinit;
    this.axios.post(conf.server+"/api/getInfoClient",{email:email},{withCredentials:true})
    .then((response2) => {
      var ref = response2.data.ref_entreprise;
      var nomEntreprise = response2.data.nom_entreprise;
      this.axios.post(conf.server+"/api/template",{template:template, email:email, pwd: pwd, tokenReinit:tokenReinit, prenom:prenom, nom:nom, ref:ref, nomEntreprise:nomEntreprise},{withCredentials:true})
      .then((response3) => {
        this.axios.post(conf.server+"/api/createAccess",{email:email, pwd:pwd, tokenReinit:tokenReinit, contenuMail:response3.data},{withCredentials:true})
        .then(() => {
          this.$refs.modalAjoutExtranet.hide();
        })
        .catch((error4)=>{
          if(error4.response != undefined){
            toasterError(`Impossible de créer l'accès à l'extranet`,'Création d\'accès')
          }else{
            toasterError(`Le service est momentanément indisponible`,'Service indisponible')
          }      
        })
      })
      .catch((error3)=>{
      if(error3.response != undefined){
        toasterError(`Impossible de charger le contenu du mail`,'Chargement du contenu du mail')
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
      })
    })
    .catch((error2)=>{
      if(error2.response != undefined){
        toasterError(`Impossible de charger les infos du client`,'Chargement des infos')
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    })
  })
  .catch((error)=>{
    if(error.response != undefined){
      toasterError(`Impossible de générer les mot de passe aléatoire`,'Génération de mot de passe')
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  })
}

//Fonction de chargement de tous les clients
async function loadingAllClient(){
  try {
    this.clientsExtranet = await requestApi({method:"GET", url:"/api/verifyAccess/", params:{id: this.$route.params.id}, form:{}, headers:{'Content-Type': 'application/json'}});
    try {
      this.tiers = await requestApi({method:"POST", url:"/api/loadingAllClient", params:{}, form:{sortfield: 't.nom'}, headers:{'Content-Type': 'application/json'}});
      this.numberOfPages = Math.ceil(this.tiers.length / this.perPage);
      for(var j=0; j<this.tiers.length; j++){
        this.tiers[j]["acces"]=false;
        this.tiers[j]["_showDetails"]=false;
        this.optionsTiers.push({value: this.tiers[j].id, text: this.tiers[j].name})
      }
      for(var i=0; i<this.clientsExtranet.length; i++){
        for(j=0; j<this.tiers.length; j++){
          if(this.tiers[j]["id"]==this.clientsExtranet[i]["socid"]){
            this.tiers[j]["acces"]=true;
          }
        }
      }
    } catch (error) {
      console.error(error);
    }
  } catch (error) {
    try {
      this.tiers = await requestApi({method:"POST", url:"/api/loadingAllClient", params:{}, form:{sortfield: 't.nom'}, headers:{'Content-Type': 'application/json'}});
      this.numberOfPages = Math.ceil(this.tiers.length / this.perPage);
      for(var j=0; j<this.tiers.length; j++){
          this.tiers[j]["acces"]=false;
          this.optionsTiers.push({value: this.tiers[j].id, text: this.tiers[j].name})
      }
      for(var i=0; i<this.clientsExtranet.length; i++){
        for(j=0; j<this.tiers.length; j++){
          if(this.tiers[j]["id"]==this.clientsExtranet[i]["socid"]){
            this.tiers[j]["acces"]=true;
          }
        }
      }
    } catch (error) {
      if(error.response != undefined){
        toasterError(`Impossible de charger les clients`,'Chargement des clients')
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    }
    if(error.response != undefined){
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  }
}

//Fonction de chargement des clients
async function loadingClient(){
  if(this.$route.params.id){
    try {
      this.clientsExtranet = await requestApi({method:"GET", url:"/api/verifyAccess/", params:{id: this.$route.params.id}, form:{}, headers:{'Content-Type': 'application/json'}});
      try {
        this.tiers = await requestApi({method:"POST", url:"/api/loadingClient", params:{}, form:{}, headers:{'Content-Type': 'application/json'}});
        this.numberOfPages = Math.ceil(this.tiers.length / this.perPage);
        console.log(this.numberOfPages)
        for(var j=0; j<this.clients.length; j++){
            this.tiers[j]["acces"]=false;
            this.tiers[j]["_showDetails"]=false;
        }
        for(var i=0; i<this.clientsExtranet.length; i++){
          for(j=0; j<this.tiers.length; j++){
            if(this.tiers[j]["id"]==this.clientsExtranet[i]["socid"]){
              this.tiers[j]["acces"]=true;
            }
          }
        }
      } catch (error) {
        if(error.response != undefined){
          toasterError(`Impossible de charger les clients`,'Chargement des clients')
        }else{
          toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
      }
    } catch (error) {
      try {
        this.tiers = await requestApi({method:"POST", url:"/api/loadingClient", params:{}, form:{}, headers:{'Content-Type': 'application/json'}});
        this.numberOfPages = Math.ceil(this.tiers.length / this.perPage);
        console.log(this.numberOfPages)
        for(var j=0; j<this.tiers.length; j++){
          this.tiers[j]["acces"]=false;
        }
        for(var i=0; i<this.clientsExtranet.length; i++){
          for(j=0; j<this.tiers.length; j++){
            if(this.tiers[j]["id"]==this.clientsExtranet[i]["socid"]){
              this.tiers[j]["acces"]=true;
            }
          }
        }
      } catch (error) {
        if(error.response != undefined){
          toasterError(`Impossible de charger les clients`,'Chargement des clients')
        }else{
          toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
      }
      if(error.response != undefined){
        if(error.response.data.route!=null){
          this.$router.push(error.response.data.route);
        }
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    }
  }
  else{
    try {
      this.clientsExtranet = await requestApi({method:"GET", url:"/api/verifyAccess/", params:{}, form:{}, headers:{'Content-Type': 'application/json'}});
      try {
        this.tiers = await requestApi({method:"POST", url:"/api/loadingClient", params:{}, form:{}, headers:{'Content-Type': 'application/json'}});
        this.numberOfPages = Math.ceil(this.tiers.length / this.perPage);
        console.log(this.numberOfPages)
        for(var j=0; j<this.clients.length; j++){
            this.tiers[j]["acces"]=false;
            this.tiers[j]["_showDetails"]=false;
        }
        for(var i=0; i<this.clientsExtranet.length; i++){
          for(j=0; j<this.tiers.length; j++){
            if(this.tiers[j]["id"]==this.clientsExtranet[i]["socid"]){
              this.tiers[j]["acces"]=true;
            }
          }
        }
      } catch (error) {
        if(error.response != undefined){
          toasterError(`Impossible de charger les clients`,'Chargement des clients')
        }else{
          //toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
      }
    } catch (error) {
      try {
        this.tiers = await requestApi({method:"POST", url:"/api/loadingClient", params:{}, form:{}, headers:{'Content-Type': 'application/json'}});
        this.numberOfPages = Math.ceil(this.tiers.length / this.perPage);
        console.log(this.numberOfPages)
        for(var j=0; j<this.tiers.length; j++){
          this.tiers[j]["acces"]=false;
        }
        for(var i=0; i<this.clientsExtranet.length; i++){
          for(j=0; j<this.tiers.length; j++){
            if(this.tiers[j]["id"]==this.clientsExtranet[i]["socid"]){
              this.tiers[j]["acces"]=true;
            }
          }
        }
      } catch (error) {
        console.error(error);
        if(error.response != undefined){
          toasterError(`Impossible de charger les clients`,'Chargement des clients')
        }else{
          toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
      }
      if(error.response != undefined){
        if(error.response.data.route!=null){
          this.$router.push(error.response.data.route);
        }
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    }
  }
}

//Fonction de chargement des dictionnaires
function loadingDictionary(){
  this.optionsPayment.push({value: "0",text: ""})
  this.optionsDeliveryDelay.push({value: "0",text: ""})
  this.axios.get(conf.server+"/api/getDictionary",{withCredentials:true})
    .then((response) => {
      var conditionPayment = response.data.conditionPayment
      var typePayment = response.data.typePayment
      var deliveryDelay = response.data.deliveryDelay
      var i
      for(i=0;i<conditionPayment.length;i++){
        this.optionsConditionsPayment.push({value: conditionPayment[i].id, text: conditionPayment[i].label})
      }
      for(i=0;i<typePayment.length;i++){
        this.optionsPayment.push({value:typePayment[i].code, text: typePayment[i].label})
      }
      for(i=0;i<deliveryDelay.length;i++){
        this.optionsDeliveryDelay.push({value: deliveryDelay[i].code, text: deliveryDelay[i].label})
      }
    })
    .catch((error) => {
      if(error.response != undefined){
        toasterError(`Impossible de charger les dictionnaires`,'Chargement des dictionnaires')
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    })
}

//Fonction de chargement des infos du compte
async function loadingInfo(){
  try {
    var response = await requestApi({method:"POST", url:"/api/loadingInfo", params:{}, form:{}, headers:{'Content-Type': 'application/json'}});
    vuexStorage.commit('updateInfo', response)
  } catch (error) {
    console.log(error);
    try {
      var response = await requestApi({method:"POST", url:"/api/disconnect", params:{}, form:{}, headers:{'Content-Type': 'application/json'}});
      this.$router.push(response.route);
    } catch (error) {
      console.log(error);
      this.$router.push('login');
    }
  }
}

//Fonction de chargement des infos du compte
async function loadingInfoClient(){
  try {
    var response = await requestApi({method:"POST", url:"/api/loadingInfo", params:{}, form:{}, headers:{'Content-Type': 'application/json'}});
      vuexStorage.commit('updateInfo', response);
      detailsTiers(response.socId, this);
  } catch (error) {
    console.log(error);
    try {
      var response = await requestApi({method:"POST", url:"/api/disconnect", params:{}, form:{}, headers:{'Content-Type': 'application/json'}});
      this.$router.push(response.route);
    } catch (error) {
      console.log(error);
      this.$router.push('login');
    }
  }
}

//Fonction de choix du template mail d'envoie de code d'accès
async function loadingTemplateMail(template,email,pwd,tokenReinit){
  try {
    var response = await requestApi({method:"POST", url:"/api/getInfoClient", params:{}, form:{email: email}, headers:{'Content-Type': 'application/json'}});
    try {
      var response2 = await requestApi({method:"POST", url:"/api/template", params:{}, form:{template : template,email: email,pwd : pwd,tokenReinit: tokenReinit, prenom : response.firstname, nom : response.lastname, ref : response.ref_entreprise, nomEntreprise : response.nom_entreprise}, headers:{'Content-Type': 'application/json'}});
      this.form.contenuMail = response2.content;
    } catch (error) {
      if(error.response != undefined){
        if(error.response.data.route!=null){
          this.$router.push(error.response.data.route);
        }else{
          this.$router.push('login');
        }
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    }
  } catch (error) {
    if(error.response != undefined){
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }else{
        this.$router.push('login');
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  }
}

//Fonction de chargement des templates mail
async function loadingTemplatesMail(){
  try {
    var response = await requestApi({method:"POST", url:"/api/templates", params:{}, form:{}, headers:{'Content-Type': 'application/json'}});
    var templateBase = {value:null, text: 'Template de base',active:1}
    this.templates.push(templateBase);
    for(var i=0; i<response.length;i++){
      var tmp = {value:response[i].value, text:response[i].text, active:response[i].active}
      this.templates.push(tmp);
    }
  } catch (error) {
    if(error.response != undefined){
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }else{
        this.$router.push('login');
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  }
}

//Fonction de chargement des templates mail actif
async function loadingTemplatesMailActive(){
  try {
    var response = await requestApi({method:"GET", url:"/api/templatesActive", params:{}, form:{}, headers:{'Content-Type': 'application/json'}});
    var templateBase = {value:null, text: 'Template de base'}
    this.templates.push(templateBase);
    for(var i=0; i<response.length;i++){
      var tmp = {value:response[i].value, text:response[i].text}
      this.templates.push(tmp);
    }
  } catch (error) {
    if(error.response != undefined){
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }else{
        this.$router.push('login');
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  }
}

//Fonction pour masquer les infos d'accès du client
function masquerInfo(){
  document.getElementById("infoContact").style.display="none";
}

//Fonction d'affichage du modal de modification des infos perso du client
function modifInfoPerso(target){
  this.$root.$emit('bv::show::modal', 'modalInfoPerso',target);
}

//Fonction pour la selection pour l'ajout de masse à l'extranet
function openAjoutExtranet(target){
  this.axios.get(conf.server+"/api/verifyAccess",{withCredentials:true})
  .then((response) => {
    this.clientsExtranet = response.data;
    this.axios.get(conf.server+"/api/loadingAllContacts",{withCredentials:true})
    .then((response) => {
      var res = response.data;
      for(var j=0; j<res.length; j++){
        res[j]["acces"]=false;
      }
      for(var i=0; i<this.clientsExtranet.length; i++){
        for(j=0; j<res.length; j++){
          if(res[j]["id"]==this.clientsExtranet[i]["contact_id"]){
            res[j]["acces"]=true;
          }
        }
      }
      for(j=0; j<res.length; j++){
        if(res[j]["acces"]==false){
          this.contacts.push(res[j]);
        }
      }
      this.$root.$emit('bv::show::modal', 'modalAjoutExtranet',target);
    })
    .catch(()=>{
    })
  })
  .catch((error) => {
    this.axios.post(conf.server+"/api/loadingAllContacts",{},{withCredentials:true})
    .then((response) => {
      this.contacts = response.data;
      for(var j=0; j<this.contacts.length; j++){
          this.contacts[j]["acces"]=false;
      }
      this.$root.$emit('bv::show::modal', 'modalAjoutExtranet',target);
    })
    .catch((error)=>{
    if(error.response != undefined){
      toasterError(`Chargement des contacts impossible`,'Chargement des contacts')

    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
    })
    if(error.response != undefined){
      if(error.response.data.route!=null){
        this.$router.push(error.response.data.route);
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  })
}

//Fonction réinitialisation du modal
function resetModal() {
  this.modalInfo.title = ''
  this.modalInfo.content = ''
}

//Fonction change password
async function setPass(){
  if(this.post.pwd==this.post.pwd2){
    try {
      await requestApi({method:"POST", url:"/api/setPass", params:{}, form:{pwd:this.post.pwd,token:this.$route.params.token}, headers:{'Content-Type': 'application/json'}});
      this.$bvToast.toast(`Changement mot de passe réussi`,{
        title: 'Changement de mot de passe',
        toaster: 'b-toaster-bottom-right',
        variant: 'success',
        autoHideDelay: 2500,
        appendToast: true,
        solid: true
      })
      this.$router.push('/');
    } catch (error) {
      if(error.response != undefined){
        if (this.post.pwd.length < 12){
          toasterError(`Le mot de passe doit faire 12 caractères minimum`,'Changement de mot de passe')
        }
        else{
          console.error(error);
          toasterError(`Changement de mot de passe impossible`,'Changement de mot de passe')
        }
      }else{
        toasterError(`Le service est momentanément indisponible`,'Service indisponible')
      }
    }
  } else {
    toasterError(`Les deux mots de passes ne correspondent pas`,'Changement de mot de passe')
  }
}

//Fonction de mise à jours des champs
async function updateFields (type, id, field, value) {
  try {
    await requestApi({method:"POST", url:"/api/updateFields", params:{}, form:{type:type,id:id,field:field,value:value}, headers:{'Content-Type': 'application/json'}});
    this.$bvToast.toast(`Les modifications ont été enregistrées`, {
      title: 'Modification rapide',
      toaster: 'b-toaster-bottom-right',
      variant: 'success',
      autoHideDelay: 2500,
      appendToast: true,
      solid: true
    })
  } catch (error) {
    toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		this.$router.push('/');
  }
}

//Fonction de vérification des droits de l'utilisateur
async function verifyRight(){
  try {
    await requestApi({method:"POST", url:"/api/verifyRight", params:{}, form:{route: this.$route.name}, headers:{'Content-Type': 'application/json'}});
  } catch (error) {
    if(error.response != undefined){
      if(error.response.status==403){
        this.$router.push('error403');
      }else{
        try {
        await requestApi({method:"POST", url:"/api/disconnect", params:{}, form:{}, headers:{'Content-Type': 'application/json'}});
        } catch (error) {
          console.error(error);
        }
        window.location = "https://"+window.location.hostname;
      }
    }else{
      toasterError(`Le service est momentanément indisponible`,'Service indisponible')
    }
  }
}



//Fonction de vérification de token
async function verifyToken(){
  try{
    var response = await requestApi({method: 'GET', url: `/api/verifyToken/${this.$route.params.token}`, params: {}, form: {}, headers: {'Content-Type': 'application/json'}});
    if(!response){
      toasterError(`Temps pour changer de mot de passe écoulé`,'Vérification')
      //this.$router.push('login');
    }
  }
  catch(error){
    console.error(error);
    toasterError(`Temps pour changer de mot de passe écoulé`,'Vérification')
    //this.$router.push('login');
  }
}

// Fonction appel api
/*
  args: options : method -- required
                  url -- required
                  params -- optional -- url parameters
                  form -- optional -- request body applicable only with PUT, POST and Patch methods
                  headers -- optional
*/
function requestApi (options) {
	return new Promise((resolve, reject) => {
		new Vue().axios({
			method: options.method,
			url: conf.server + options.url,
			params: options.params,
			data: options.form,
			headers: options.headers,
			withCredentials: true
		}).then((response) => {
			resolve(response.data)
		}).catch((error) => {
			reject(error)
		})
	})
}

export default {
  disconnect,
  loadingInfo,
  isConnect,
  verifyRight,
  loadingClient,
  loadingAllClient,
  expandClientInfo,
  createAccess,
  deleteAccess,
  masquerInfo,
  info,
  resetModal,
  loadingTemplatesMailActive,
  loadingTemplatesMail,
  loadingTemplateMail,
  connectOnClient,
  getInfoClient,
  getInfoSocClient,
  changePassword,
  modifInfoPerso,
  changeInfoPerso,
  activeClassMenuProfil,
  changePassOublie,
  verifyToken,
  detailsTiers,
  updateFields,
  addContact,
  delContact,
  deleteTiers,
  setPass,
  openAjoutExtranet,
  addMassiveContact,
  loadingDictionary,
  toasterError,
  loadingInfoClient,
  requestApi,
};
